export default "__VITE_ASSET__DEILRGHb__"